import { VentaApi as Api } from "./venta.api";

export class VentaFacade {
    static approveById(pagoId) {
        return Api.approveById(pagoId);
    }
    static getPendingList() {
        return Api.getPendingList();
    }
    static rejectById(pagoId) {
        return Api.rejectById(pagoId);
    }
}